// Components
import { GameScore, SMPFlex, SMPText } from '../../../index';

// Types
import { LIVE } from '../../../../constants/statusTypes';
import { LIVE_VARIANT, PRIMARY_GRAY_VARIANT } from '../../../../constants/statusTextVariants';
import { INormalizedMatchData } from '../../../../types';
import { constructEventStatusInfo, getMatchMinutes } from '@sportal365/smp-widget-utils';

export interface ISingleEventInfoProps {
  match: INormalizedMatchData;
  matchLink?: string;
  handleEventClick?: (id: string | number) => void;
  dataShortStatusType?: string | null;
  displayDate?: boolean;
}

export const EventInfo = ({
  match,
  matchLink,
  handleEventClick,
  dataShortStatusType,
  displayDate = true,
}: ISingleEventInfoProps): JSX.Element => {
  const [_shouldShowDate, matchDate] = match.date as [boolean, string];
  const statusTextVariant = match?.matchStatus?.type === LIVE ? LIVE_VARIANT : PRIMARY_GRAY_VARIANT;
  const showPenaltyScore = Boolean(
    match.score?.penaltyShootout && match.score?.penaltyShootout?.home && match.score?.penaltyShootout?.away,
  );
  const isMatchLive = match.matchStatus?.type === 'LIVE';

  return (
    <SMPFlex variant='score' grow='10' shrink='1' basis='auto' css={{ minWidth: '75px' }}>
      {match?.matchStatus?.code === 'not_started' || match?.matchStatus?.code === 'postponed' ? (
        <a
          href={matchLink}
          target={match.urlTarget}
          onClick={() => handleEventClick && handleEventClick(match.id)}
          style={{ display: 'inline-flex', textDecoration: 'none' }}
        >
          <SMPText variant='contrast' size='6' weight='900'>
            {match.status}
          </SMPText>
        </a>
      ) : (
        <GameScore
          eventId={match.id}
          handleEventClick={handleEventClick}
          matchUrlTarget={match?.urlTarget}
          matchLink={matchLink}
          homeTeamScore={match.homeTeamScore}
          awayTeamScore={match.awayTeamScore}
        />
      )}
      {match?.minute ? (
        <SMPText css={{ mt: '$2' }} size='2' weight='700' variant='green'>
          {getMatchMinutes(match.minute)}
        </SMPText>
      ) : (
        <>
          {displayDate && (
            <SMPText css={{ mt: '$2' }} size='2' variant='primaryGray'>
              {matchDate}
            </SMPText>
          )}
          {match?.matchStatus?.code !== 'not_started' && (
            <SMPText css={{ mt: '$2' }} variant={statusTextVariant} size='2' weight='700'>
              {constructEventStatusInfo(match, dataShortStatusType) && showPenaltyScore && isMatchLive
                ? `${constructEventStatusInfo(match, dataShortStatusType)}'`
                : constructEventStatusInfo(match, dataShortStatusType)}
            </SMPText>
          )}
          {showPenaltyScore && isMatchLive && (
            <SMPText css={{ mt: '$2' }} variant='contrast' size='2' weight='700'>
              ({match.score?.penaltyShootout?.home} - {match.score?.penaltyShootout?.away})
            </SMPText>
          )}
        </>
      )}
    </SMPFlex>
  );
};
